import { classNames } from "@greeter/util";
import { TimeOfDay } from "@greeter/date";

import css from "./Clock.module.scss";

export type ClockProps = {
  time: TimeOfDay;
  className?: string;
};

export function Clock({ time, className }: ClockProps) {
  return <p {...classNames(css.Clock, className)}>{time.toString()}</p>;
}
